/**
 * @fileoverview Agent definition for character-snapshotter-v2.
 *
 * This composite agent orchestrates entity detection and per-character snapshot
 * generation. It first detects which characters appear in a chapter, then
 * generates individual snapshots for each present character in parallel.
 *
 * Orchestrated agents:
 * - chapter-entity-detector-v2: Detects which characters appear in the chapter
 * - character-snapshotter-single-v2: Generates snapshot for each detected character
 *
 * @category entities.characters.analysis
 * @type composite
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'character-snapshotter-v2',
  kind: 'composite',
  name: 'Character Snapshotter',
  description: 'Detects characters present in a chapter and generates state snapshots for each in parallel.',
  category: 'characters',
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'composite',
    addedIn: '2026-02',
    lastUpdated: '2026-02',
    taxonomyPath: 'entities.characters.analysis',
    usedBy: [
      'use-character-snapshotter-single-v2.ts',
    ],
    usedInComposites: [],
    composedOf: [
      'chapter-entity-detector-v2',
      'character-snapshotter-single-v2',
    ],
    relatedAgents: [
      'chapter-entity-detector-v2',
      'character-snapshotter-single-v2',
    ],
  },
};
